import { render, staticRenderFns } from "./ClearData.vue?vue&type=template&id=d9818f0c&scoped=true"
import script from "./ClearData.vue?vue&type=script&lang=js"
export * from "./ClearData.vue?vue&type=script&lang=js"
import style0 from "./ClearData.vue?vue&type=style&index=0&id=d9818f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9818f0c",
  null
  
)

export default component.exports